<script setup lang="tsx">
import { ref, watchEffect } from "vue";
import { __color } from "@zyzgroup/core-web";
import { mapState } from "../../context/context";

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {}
);

const mappedState = mapState(["color.yellowCommon"]);

const color = ref();
const oppositeColor = ref();

watchEffect(() => {
  color.value = props.color || mappedState["color.yellowCommon"].value;
  oppositeColor.value = __color.set(color.value).opposite(true).toString();
});
</script>

<template>
  <!-- 不设置 width="64" height="64" 自适应父元素 -->
  <!-- viewBox : x y width height , 可重设 viewBox 切除四周多余空白 -->
  <svg
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="none"
    fill="none"
    :style="{
      display: 'block',
      transformOrigin: 'center'
    }"
  >
    <path
      d="M32 62C48.5685 62 62 48.5685 62 32C62 15.4315 48.5685 2 32 2C15.4315 2 2 15.4315 2 32C2 48.5685 15.4315 62 32 62Z"
      :fill="color"
    />
    <rect
      x="30"
      y="14"
      width="4"
      height="22"
      rx="2"
      :fill="oppositeColor"
    />
    <rect
      x="50"
      y="32"
      width="4"
      height="20"
      rx="2"
      transform="rotate(90 50 32)"
      :fill="oppositeColor"
    />
  </svg>
</template>
